<ion-content>
  <app-global-page-header
    [title]="'components.notConnectedModal.title' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    @if (!connectionInProgress) {
      <p>
        {{ 'pages.pools.detail.pool.messsage3' | translate }}
      </p>
    } @else {
      <div class="text-center">
        <ion-spinner name="circular"></ion-spinner>
      </div>
    }
  </div>
</ion-content>

<ion-footer class="p-3">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button color="medium" fill="outline" (click)="dismissModal()">
        {{ 'components.notConnectedModal.stayDisconnected' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button
        color="primary"
        (click)="startConnection()"
        [disabled]="connectionInProgress"
      >
        {{ 'components.notConnectedModal.connect' | translate }}
      </ion-button>
    </div>
  </div>
</ion-footer>
